import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PdfOrderViewRoutingModule } from './pdf-order-view-routing.module';
import { PdfOrderViewComponent } from './pdf-order-view.component';
import { PDFModule } from 'app/pdf/pdf.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { I18nModule } from 'app/shared/i18n/i18n.module';

@NgModule({
  imports: [
    CommonModule,
    PdfOrderViewRoutingModule,
    PDFModule,
    NgxSpinnerModule,
    I18nModule
  ],
  declarations: [PdfOrderViewComponent]
})
export class PdfOrderViewModule { }
